import { render, staticRenderFns } from "./ChangeNoticeType.vue?vue&type=template&id=9a92ca54"
import script from "./ChangeNoticeType.vue?vue&type=script&lang=js"
export * from "./ChangeNoticeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports